import React from "react";
import Option from "./filter";

interface QuestionProps extends React.HTMLAttributes<HTMLDivElement> {
  question: string;
  filters: string[];
  selectedFilters: string[];
  setSelectedFilters: React.Dispatch<
    React.SetStateAction<{
      [x: string]: string[];
    }>
  >;
}

const Question: React.FC<QuestionProps> = ({
  question,
  filters,
  selectedFilters = [],
  setSelectedFilters,
}) => {
  const handleClick = (filter: string) => {
    const newSelectedFilters = [...selectedFilters];
    const index = newSelectedFilters.indexOf(filter);

    if (index < 0) {
      newSelectedFilters.push(filter);
    } else {
      newSelectedFilters.splice(index, 1);
    }

    setSelectedFilters((prev) => ({
      ...prev,
      [question]: newSelectedFilters,
    }));
  };

  return (
    <>
      <div className="question">
        <div className="title">{question}</div>
        <div className="options">
          {filters.map((filter) => {
            return (
              <Option
                key={filter}
                isSelected={selectedFilters.includes(filter)}
                onClick={() => handleClick(filter)}
              >
                {filter}
              </Option>
            );
          })}
        </div>
      </div>
      <style jsx>{`
        .question {
          width: 100%;
          margin-bottom: 16px;

          .title {
            color: #191919;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 100%; /* 16px */

            margin-bottom: 16px;
          }

          .options {
            display: flex;
            flex-wrap: wrap;
          }
        }
        @media (max-width: 768px) {
          .question {
            .title {
              line-height: 130%; /* 19.5px */
            }
          }
        }
      `}</style>
    </>
  );
};

export default Question;
